<template>
  <div class="exc-ticker-logos-block">
    <!-- for single logo -->
    <div
      v-if="!fiatLogo && !cryptoLogo && tickerLogo"
      class="exc-ticker-logos-block__container mt-auto mb-auto"
    >
      <div class="exc-ticker-logos-block__right-bottom">
        <exc-ticker-logo
          :src="tickerLogo"
          :transparent-border="transparentBorder"
          size="s"
        />
      </div>
    </div>

    <!-- for double logos -->
    <div
      v-if="fiatLogo && cryptoLogo && !tickerLogo"
      class="exc-ticker-logos-block__container mt-auto mb-auto"
    >
      <div class="exc-ticker-logos-block__left-top">
        <exc-ticker-logo
          :src="fiatLogo"
          :transparent-border="transparentBorder"
          size="m"
        />
      </div>
      <div class="exc-ticker-logos-block__icon">
        <!-- TODO: fix svg icon -->
        <!-- <icon-arrow-curve /> -->
        <img src="@/assets/icons/arrow-curve.svg" alt="arrows">
      </div>
      <div class="exc-ticker-logos-block__right-bottom">
        <exc-ticker-logo
          :src="cryptoLogo"
          :transparent-border="transparentBorder"
          size="m"
        />
      </div>
    </div>

    <!-- pass here any other thing via slot -->
    <div v-if="$slots['content']" class="exc-ticker-logos-block__content">
      <slot name="content" />
    </div>

    <div class="exc-ticker-logos-block__block-title ml-16">
      <slot name="mobile-block" />
    </div>
  </div>
</template>
<script>
// import adminPageCheker from '@/mixins/adminPageChecker'
import ExcTickerLogo from '@/components/common/ticker/ExcTickerLogo.vue'
// import IconArrowCurve from 'src/icons/arrows/icon-arrow-curve.svg'

export default {
  name: 'ExcTickerLogosBlock',
  components: {
    // IconArrowCurve,
    ExcTickerLogo,
  },
  // mixins: [adminPageCheker],
  props: {
    // for single logo with percent image
    tickerLogo: { type: String, default: '' },

    // for double logos with two arrows
    fiatLogo: { type: String, default: '' },
    cryptoLogo: { type: String, default: '' },
    lineOnLeft: { type: Boolean, default: false },
    transparentBorder: { type: Boolean, default: false },
  },
}
</script>
<style lang="scss" scoped>
.exc-ticker-logos-block {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  @include bp(s) {
    align-items: initial;
  }

  &__container {
    $sizeMobile: 18px;
    $sizeDesktop: 25px;
    display: grid;
    grid-gap: 3px;
    grid-template-rows: $sizeDesktop;
    grid-template-columns: $sizeDesktop $sizeDesktop $sizeDesktop;
    padding-top: 0;
    grid-template-areas: 'left-top icon right-bottom';

    & > * {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    & img,
    svg {
      max-width: 100%;
      height: auto;
    }
  }

  &__content {
    display: flex;
    width: 100%;
  }

  &__left-top {
    grid-area: left-top;
  }

  &__right-top {
    grid-area: right-top;
  }

  &__right-bottom {
    grid-area: right-bottom;
  }

  &__left-bottom {
    grid-area: left-bottom;
  }

  &__left-top,
  &__right-bottom {
    border-radius: 999px;

    img,
    svg {
      max-height: 100%;
      max-width: 100%;
    }
  }

  &__block-title {
    flex: 1;
    @include bp(s) {
      display: none;
    }
  }
}
</style>
